document.addEventListener('DOMContentLoaded', function() {
    // 处理默认选中的选项
    const checkedInput = document.querySelector('.product input[type="radio"][checked]');
    if (checkedInput) {
        const checkedLabel = document.querySelector(`label[for="${checkedInput.id}"]`);
        if (checkedLabel) {
            const labelTitle = checkedLabel.getAttribute('title');
            
            // 检查是否存在匹配的媒体元素
            // ✅ UPDATED: Use startsWith so alt text like "Blush Fei and Eve Classic Harness"
            // still matches a variant named "Blush"
            const hasMatchingMedia = Array.from(document.querySelectorAll('[data-media-alt]'))
                .some(element => {
                    const mediaAlt = element.getAttribute('data-media-alt');
                    return mediaAlt && mediaAlt.startsWith(labelTitle);
                });

            // 处理对应的媒体元素
            document.querySelectorAll('[data-media-alt]').forEach(element => {
                const mediaAlt = element.getAttribute('data-media-alt');
                if (hasMatchingMedia) {
                    // ✅ UPDATED: Use startsWith instead of ===
                    if (mediaAlt && mediaAlt.startsWith(labelTitle)) {
                        element.style.display = 'block';
                        element.classList.remove('swiper-slide-hidden');
                        element.classList.add('swiper-slide');
                    } else {
                        element.style.display = 'none';
                        element.classList.add('swiper-slide-hidden');
                        element.classList.remove('swiper-slide');
                    }
                } else {
                    // 如果没有匹配的媒体元素，显示所有元素
                    element.style.display = 'block';
                    element.classList.remove('swiper-slide-hidden');
                    element.classList.add('swiper-slide');
                }
            });

            // 更新 Swiper 实例
            document.querySelectorAll('.swiper').forEach(swiperEl => {
                if (swiperEl.swiper) {
                    swiperEl.swiper.update();
                    swiperEl.swiper.slideTo(0, 0);
                }
            });
        }
    }

    // 点击事件处理（仅监听每个 variant-radios 内的第一个 fieldset）
    document.querySelectorAll('variant-radios').forEach(vr => {
        const firstFieldset = vr.querySelector('fieldset');
        if (!firstFieldset) return;

        firstFieldset.querySelectorAll('label.color-swatch, label.option-Size, label').forEach(label => {
            label.addEventListener('click', function() {
                const labelTitle = this.getAttribute('title');

                // ✅ UPDATED: Use startsWith so alt text like "Blush Fei and Eve Classic Harness"
                // still matches a variant named "Blush"
                const hasMatchingMedia = Array.from(document.querySelectorAll('[data-media-alt]'))
                    .some(element => {
                        const mediaAlt = element.getAttribute('data-media-alt');
                        return mediaAlt && mediaAlt.startsWith(labelTitle);
                    });

                document.querySelectorAll('[data-media-alt]').forEach(element => {
                    const mediaAlt = element.getAttribute('data-media-alt');
                    if (hasMatchingMedia) {
                        // ✅ UPDATED: Use startsWith instead of ===
                        if (mediaAlt && mediaAlt.startsWith(labelTitle)) {
                            element.style.display = 'block';
                            element.classList.remove('swiper-slide-hidden');
                            element.classList.add('swiper-slide');
                        } else {
                            element.style.display = 'none';
                            element.classList.add('swiper-slide-hidden');
                            element.classList.remove('swiper-slide');
                        }
                    } else {
                        element.style.display = 'block';
                        element.classList.remove('swiper-slide-hidden');
                        element.classList.add('swiper-slide');
                    }
                });

                document.querySelectorAll('.swiper').forEach(swiperEl => {
                    if (swiperEl.swiper) {
                        swiperEl.swiper.update();
                        swiperEl.swiper.slideTo(0, 0);
                    }
                });
            });
        });
    });
});
// document.addEventListener('DOMContentLoaded', function() {
//     document.querySelectorAll('.product-media-modal__toggle').forEach(button => {
//         button.addEventListener('click', function() {
//             setTimeout(() => {
//                 // 先销毁现有的 Swiper 实例
//                 document.querySelectorAll('.js-media-list, .js-media-sublist').forEach(swiperEl => {
//                     if (swiperEl.swiper) {
//                         swiperEl.swiper.update();
//                         // 重置到第一张幻灯片
//                         swiperEl.swiper.slideTo(0, 0);
//                     }
//                 });
//             }, 100);
//         });
//     });
// });